import React from 'react';

import cn from 'classnames';
import { MdError } from 'react-icons/md';

import { intl } from '@modules/shared/localization/translate';
import S from '@shared/components/S';
import type { SProps } from '@shared/components/S/S';

import styles from './Amount.less';

type AmountProps = {
  amount: number;
  semibold?: boolean;
  bold?: boolean;
  className?: string;
  currency?: string;
  noContainer?: boolean;
  addCurrency?: boolean;
  errorIndicator?: boolean;
  redNegative?: boolean;
  greenPositive?: boolean;
  size?: SProps['size'];
};

const Amount = ({
  amount,
  semibold,
  bold,
  className,
  currency = 'USD',
  noContainer,
  addCurrency,
  errorIndicator,
  redNegative,
  greenPositive,
  size,
}: AmountProps) => {
  const isNegative = amount < 0;
  const isPositive = amount > 0;
  const negativeTextStyle = redNegative && isNegative ? 'text-danger' : '';
  const positiveTextStyle = greenPositive && isPositive ? 'text-success' : '';
  const containerStyle = noContainer ? '' : styles.container;
  const errorIcon =
    isNegative && errorIndicator ? (
      <MdError className={cn(styles.errorIcon, styles[`errorIcon-${size}`])} />
    ) : null;

  const formattedAmount = new Intl.NumberFormat(intl.locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
    currency,
    currencySign: 'accounting',
  }).format(amount);

  return (
    <S
      semibold={semibold}
      bold={bold}
      className={cn(
        containerStyle,
        negativeTextStyle,
        positiveTextStyle,
        className,
      )}
      size={size}
    >
      {errorIcon}
      {formattedAmount}
      {addCurrency && ` ${currency}`}
    </S>
  );
};

export default Amount;
